import React from 'react';
import Icon from 'src/components/Icon';

// Overrides RJSF's default UnsupportedField. The stock component renders the
// offending schema inside a bare <pre>, which has no width constraint: a long
// JSON line forces the flex column to grow, deforming the page and shoving the
// WorkTray to the right. This version keeps the error fully contained — the
// wrapper is `min-w-0 max-w-full overflow-hidden`, text wraps, and the JSON
// preview scrolls inside a bounded box instead of expanding its parent.
interface UnsupportedFieldProps {
  schema?: unknown;
  idSchema?: { $id: string };
  reason?: string;
}

function UnsupportedField({ schema, idSchema, reason }: UnsupportedFieldProps) {
  const fieldId = idSchema && idSchema.$id;

  return (
    <div className="min-w-0 max-w-full overflow-hidden rounded-lg border border-amber-300 bg-amber-50 dark:border-amber-500/40 dark:bg-amber-500/10 p-3 text-sm">
      <div className="flex items-start gap-2 text-amber-700 dark:text-amber-300">
        <Icon icon="Warning" className="mt-0.5 shrink-0" />
        <div className="min-w-0">
          <p className="font-medium break-words">
            This field could not be rendered
            {fieldId ? (
              <>
                {' '}
                (<code className="break-all">{fieldId}</code>)
              </>
            ) : null}
          </p>
          {reason ? (
            <p className="mt-0.5 break-words text-amber-600 dark:text-amber-400/90">{reason}</p>
          ) : null}
        </div>
      </div>
      {schema ? (
        <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded bg-black/5 dark:bg-white/5 p-2 text-xs text-amber-800 dark:text-amber-200">
          {JSON.stringify(schema, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}

export default UnsupportedField;
